import { FC, useState, useEffect } from "react";
import Input from "shared/Input/Input";
import Select from "shared/Select/Select";
import Textarea from "shared/Textarea/Textarea";
import CommonLayout from "./CommonLayout";
import FormItem from "./FormItem";
import { IInput } from "types/interfaces";
import { useDispatch, useSelector } from "react-redux";
import { addListing1, addListingStart } from "actions/addListingActions";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import { useHistory } from "react-router-dom";
import { RootState } from "store";
import { getAddress } from "actions/addressActions";

export interface PageAddListing1Props {}

const categories = [
  "Transportasi",
  "Pakaian",
  "Keperluan Anak",
  "Furnitur",
  "Gadget",
  "Outdoor",
  "Keperluan Pribadi",
];

const PageAddListing1: FC<PageAddListing1Props> = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { product } = useSelector((state: RootState) => state.productUpload);

  const [itemName, setItemName] = useState<IInput>({
    value: product.name,
    warning: "",
  });
  const [itemCategory, setItemCategory] = useState<string>(product.category);
  const [itemDescription, setItemDescription] = useState<string>(
    product.description
  );

  const handleSubmit = (e: any) => {
    if (!itemName.value)
      setItemName({
        value: itemName.value,
        warning: "Masukkan nama barang anda",
      });
    else {
      dispatch(addListing1(itemName.value, itemCategory, itemDescription));
      history.push("/add-listing-2");
    }
    e.preventDefault();
  };

  useEffect(() => {
    dispatch(getAddress());
    dispatch(addListingStart());
  }, []);

  return (
    <CommonLayout index="01">
      <>
        <h2 className="text-2xl font-semibold">Keterangan Umum</h2>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
        {/* FORM */}
        <form className="space-y-8" onSubmit={handleSubmit}>
          {/* ITEM */}
          <FormItem
            label="Nama Barang"
            desc="Masukkan nama barangmu sekreatif dan semenarik mungkin"
            required={true}
          >
            <Input
              placeholder="Kamera DSLR"
              value={itemName.value}
              onChange={(e) =>
                setItemName({ value: e.target.value, warning: "" })
              }
            />
            {itemName.warning && (
              <span className="text-red-600 text-sm">{itemName.warning}</span>
            )}
          </FormItem>
          <FormItem
            label="Kategori Barang"
            desc="Pilih kategori barang yang paling sesuai dengan barangmu"
            required={true}
          >
            <Select
              onChange={(e) => setItemCategory(e.target.value)}
              value={itemCategory}
            >
              {categories.map((category) => {
                return (
                  <option key={category} value={category}>
                    {category}
                  </option>
                );
              })}
            </Select>
          </FormItem>

          <FormItem
            label="Deskripsi Barang"
            desc="Deskripsikan barangmu secara singkat dan jelas"
          >
            <Textarea
              placeholder="Keterangan barang"
              value={itemDescription}
              onChange={(e) => setItemDescription(e.target.value)}
            ></Textarea>
          </FormItem>
          <div className="flex justify-end space-x-5">
            <ButtonSecondary href={"/add-listing-1"}>Kembali</ButtonSecondary>
            <ButtonPrimary type="submit">{"Selanjutnya"}</ButtonPrimary>
          </div>
        </form>
      </>
    </CommonLayout>
  );
};

export default PageAddListing1;
